import React, {useState} from "react";
import {Link} from "react-router-dom";
import {isMobile} from "react-device-detect";
import {prettyUrl} from "../../utils/UrlUtils";
import {t} from "../../i18n";
import {GamePromo} from "../../contenful/types";
import {useSelector} from "react-redux";
import {getJackpotAmountByGame} from "../../selectors/casino-selectors";
import {AppState} from "../../RootReducer";
import { useCasinoFilterParams } from "../../casino/ui/CasinoFilterParams";

interface Props {
    list?: GamePromo[];
    listId?: any;
}

interface OtherProps {
    hoverPlayButton?: boolean;
}
type AllProps = OtherProps & Props;


export function toLaunchUrl(gameId: string | undefined, name: string | undefined) {
    return `/casino/play/${gameId ?? ""}/${prettyUrl(`${name ? name : ''}`)}/auto`;
}

const PromoItem = (props : { name? : string, gameProvider? : string, new?: boolean, backgroundImage?: string, logoImage?: string,
    gameId?: string, providerId?: string, hoverPlayButton?: boolean }) => {
    const [error, setError] = useState(false);
    const {filterProviders} = useCasinoFilterParams();
    let target = "#"
    let click = (e: any) => {}

    const jackpot = useSelector((app : AppState) => getJackpotAmountByGame(app, Number(props.gameId) ?? -1))

    if (props.providerId) {
        click = (e: any) => filterProviders([parseInt(props.providerId!)])
    } else {
        let gameId = props.gameId;
        let name = props.name;
        target = toLaunchUrl(gameId,name);
    }
    return (
        <Link to={target} className={`card-wrapper ${props.hoverPlayButton ? `play-button` : ''}`} onClick={click}>
            {props.new && (
                <div className="ribbon-wrapper">
                    <span className="ribbon">{t("common.new")}</span>
                </div>
            )}
            <div className="card-game-list">
                {error && <div className={"error-bg"}><span>{props.name}</span></div>}
                {props.backgroundImage && !error && <img src={props.backgroundImage}
                                                   onError={()=>setError(true)}
                                                   className={"bg"} alt={props.name ? props.name : ''}/>}
                <div className="card-inner">
                    {props.logoImage && <img src={props.logoImage}
                                                 className="logo" alt={props.name ? props.name : ''}/>}
                </div>
            {props.hoverPlayButton &&
                <div className="content-overlay"></div>
            }
            </div>
            {props.hoverPlayButton === undefined && (
                <div className={"card-game-name"}>
                    {props.name &&  <p className="name">{props.name}</p>}
                    {props.gameProvider && <p className="provider">{props.gameProvider}</p>}
                </div>
            )}
            {props.hoverPlayButton &&
            (<div className={"game-play-button"}>
                <span className={"click-to-play"}>
                    <i className={"material-icons"}>play_circle_filled</i>
                </span>
            </div>)
            }
            {jackpot && (
                <div className={"jackpot-container"}>
                        <div className={"jackpot-amount"}>
                            {jackpot}
                        </div>
                </div>
            )}
        </Link>
    )
}


const ListOfGamePromo = (props: AllProps) => {
    let list = props.list;

    const mobile = isMobile ? 'mobile slide' : ''
    const size =  list?.length ?? 1;
    let columnSize = size > 5 ? 6 : list?.length

    const playButton = props.hoverPlayButton && props.hoverPlayButton
    return (
        <div className={`container-inner column-size-${columnSize} ${mobile}`}>
            {list && list.length > 0 && list.map((listPromo:GamePromo, idx:any) => {
                    return(
                        <PromoItem gameId={listPromo.gameId} backgroundImage={listPromo.backgroundImage?.fields?.file?.url}
                            logoImage={listPromo.logoImage?.fields?.file?.url} name={listPromo.name}
                            new={listPromo.new} key={idx} gameProvider={listPromo.gameProvider}
                            providerId={listPromo.gameProviderId} hoverPlayButton={playButton}/>
                    )
                }
            )}
        </div>
    )

}

export default ListOfGamePromo;

